<template>
  <div class="bg-white shadow p-10 rounded w-full mx-auto max-w-2xl">
    <div class="flex items-center justify-center">
      <div
        class="flex items-center py-2"
        v-if="company && company.logo && company.logo_url"
      >
        <img
          class="h-12 w-auto"
          @error="company.logo = false"
          style="object-fit: scale-down; min-height: 100%"
          :src="company.logo_url"
          :alt="company.name"
        />
      </div>
      <div
        v-else
        class="h-16 w-16 flex rounded-full items-center justify-center"
      >
        <img
          class="h-14 w-14"
          :src="'/images/security.svg'"
          alt=""
        />
      </div>
    </div>

    <h1 class="text-center text-lg font-bold mt-8 mb-4 text-blue-900">Verify your identity</h1>
    <div class="max-w-md mx-auto">
      <div class="text-sm sm:text-base text-gray-600 text-center m-3 mx-auto">
        For security, we need to verify your identity. Click continue to receive your verification code via
        {{ contact.phone_number?.mfa_enabled ? "sms" : "email" }}.
      </div>

      <div class="mt-4 text-gray-600 text-center">
        <div class="flex-grow">
          <div class="font-semibold text-sm mb-1">{{ contact.name }}</div>
          <div class="text-gray-500 text-sm mb-10">
            {{ contact.phone_number?.mfa_enabled ? getPhoneNumber() : contact.email }}
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-center text-sm">
      <div class="">
        <v-button
          :loading="loading"
          @click.prevent="submit"
          class="bg-primary-600 hover:bg-primary-500 text-white h-14 w-64 text-center"
        >
          <template
            #title
            v-if="!loading"
            >Continue</template
          >
          <template
            #icon
            v-if="!loading"
            class="icon"
          >
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </template>
        </v-button>
      </div>
    </div>
  </div>
</template>

<script>
import ClientSpinner from "../../ClientSpinner.vue"
import Avatar from "../../UI/Avatar.vue"
import VButton from "../../components/VButton.vue"
import Errors from "../../../js/helpers/Errors"

export default {
  name: "ClientAuthPreface",

  components: {
    ClientSpinner,
    Avatar,
    VButton,
  },

  props: {
    user: { required: true, type: Object },
    contact: { required: true, type: Object },
    company: { required: true, type: Object },
    project: { required: true, type: Object },
  },

  data() {
    return {
      loading: false,
    }
  },

  methods: {
    async submit() {
      this.loading = true

      try {
        const { _auth } = this.$route.query
        await axios.post(`/api/client-portal/verification-code/${this.project.id}`, {
          _auth,
        })
        this.$emit("continue")
      } catch (e) {
        if (e.response && e.response.status === 403) {
          alert("You are not authorized to access this page or the link could be malformed.")
        } else if (e.response && e.response.status === 422) {
          alert(new Errors(e.response.data).toArray().join("\n"))
        } else {
          alert("Unable to generate code. Please try refreshing the page or contact us.")
        }
        console.error(e)
      }

      this.loading = false
    },

    getPhoneNumber() {
      const phone = this.contact.phone_number

      if (!phone || !phone.mfa_enabled) {
        return null
      }

      return `${phone.phone}`
    },
  },
}
</script>

<style scoped></style>
